import {
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel, MenuItem, Select,
} from "@mui/material";
import {RbRoundButton} from "../../../shared-components/rb-components/RbRoundButton";
import React, {useEffect, useState} from "react";
import {RbDialog} from "app/shared-components/dialogs/RbDialog";
import {IProjectDropDown, RbTheme, UserOrganization} from "../../../types/common-types";
import {useTheme} from "@mui/material/styles";
import {getAllOrganizationProjects} from "../../../services/common/common";
import {RbTextField} from "../../../shared-components/rb-components/RbTextField";
import {RbSubSection, RbSubSectionItem} from "app/shared-components/rb-components/RbSections";
import {createNewBoard} from "../../../services/boards/boardsService";
import {connect} from "react-redux";
import withRouter from "../../../../@fuse/core/withRouter";

function CreateNewBoardDialog(props: { open: boolean, onClose: (update?: boolean) => void, organization: UserOrganization }) {
    const theme: RbTheme = useTheme();
    const [projects, setProjects] = useState<IProjectDropDown[]>([]);
    const [project, setProject] = useState<IProjectDropDown>({id: ""} as any);
    const [boardTitle, setBoardTitle] = useState<string>("");

    useEffect(() => {
        _getAllOrganizationProjects();
    }, [props?.organization?.id]);

    function _getAllOrganizationProjects() {
        if (!props?.organization?.id) return;
        getAllOrganizationProjects(props.organization.id).then(res => {
            if (res?.data?.error) return;
            setProjects(res.data.data);
        });
    }

    function _createNewBoard() {
        createNewBoard(boardTitle, project.id).then(res => {
            if (res?.data?.error) return;
            props.onClose(true);
        });
    }

    return (
        <RbDialog
            open={props.open}
            onClose={() => props.onClose()}
        >
            <DialogTitle>Create board</DialogTitle>
            <DialogContent>
                <RbSubSectionItem>
                    <FormControl fullWidth>
                        <RbTextField className="w-512"
                                     variant="outlined"
                                     label="Title"
                                     autoFocus={true}
                                     onChange={e => setBoardTitle(e.target.value)}
                                     color="primary"/>
                    </FormControl>
                </RbSubSectionItem>

                <RbSubSection>
                    <FormControl fullWidth>
                        <InputLabel id="project">Project</InputLabel>
                        <Select
                            labelId="project"
                            label="Project"
                            variant="outlined"
                            value={project?.id}
                        >
                            {projects.map((proj: IProjectDropDown) => (
                                <MenuItem key={proj.id}
                                          onClick={() => setProject(proj)}
                                          value={proj?.id}>{proj?.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </RbSubSection>
            </DialogContent>
            <DialogActions>
                <RbRoundButton disabled={!project?.id || !boardTitle} style={{color: theme.palette.text.primary}}
                               variant="contained" onClick={_createNewBoard}>Create</RbRoundButton>
            </DialogActions>
        </RbDialog>
    )
}

// @ts-ignore
function mapStateToProps({fuse}) {
    return {
        organization: fuse.organization.value,
    }
}

export default withRouter(connect(mapStateToProps)(CreateNewBoardDialog));
